import { Component, OnInit } from '@angular/core';
import { IProfile } from '../shared/interfaces/profile';
import { ProfileService } from '../shared/services/profile.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  profile: IProfile;

  constructor(private profileService: ProfileService) { }

  ngOnInit(): void {
    this.profile = this.profileService.getProfile();
  }

}
